import { Component, OnDestroy, OnInit } from '@angular/core';

import { ReportImportService } from 'src/app/services/report-import/report-import.service';

@Component({
  selector: 'app-report-progress',
  templateUrl: './report-progress.component.html',
  styleUrls: ['./report-progress.component.scss']
})
export class ReportProgressComponent implements OnInit, OnDestroy {
  public state: 'closed' | 'checking' | 'opened' | 'started' | 'processing' | 'ended' | 'error' = 'checking';
  public progress = 0;
  public message = '';
  public title = '';
  public result = this.service.progressResult;

  constructor(private service: ReportImportService) {}

  public ngOnInit(): void {
    this.service.startListeningProgress();
    this.displayProgress(this.service.progressSource);
    return;
  }

  public ngOnDestroy(): void {
    this.closeProgress();
  }

  private closeProgress(): void {
    if (this.source) this.source.close();
  }

  private source: EventSource | undefined;

  private displayProgress(source: EventSource): void {
    source.addEventListener('data', (event) => {
      const progress = JSON.parse(event.data) as ProgressEvents;

      this.setTitle(progress.category);

      if (progress.type === 'start') {
        this.state = 'started';
        this.message = progress.message || '';
      }

      if (progress.type === 'process') {
        this.state = 'processing';
        this.progress = (progress.current / progress.total) * 100;
        this.message = progress.message;
      }

      if (progress.type === 'end' && this.state !== 'error') {
        this.state = 'ended';
        this.progress = 100;
        this.message = 'OK';

        this.service.endListeningProgress('');
      }

      if (progress.type === 'error') {
        this.state = 'error';

        this.message = 'Erreur serveur';
      }
    });
  }

  public clearProgress(): void {
    this.state = 'closed';
    this.progress = 0;
    this.message = '';
    this.title = '';
    this.service.progressResult.next('');
  }

  public refreshProgress(): void {
    this.clearProgress();
    this.service.refreshListetingProcess();
    this.displayProgress(this.service.progressSource);
  }

  public setTitle(category: ImportCategory): void {
    switch (category) {
      case 'gallery':
        this.title = 'Import des donneés des galeries commerciales';
        break;
      case 'location':
        this.title = 'Import des donneés des locations';
        break;
      case 'monthly_report':
        this.title = 'Import des donneés des rapports mensuels';
        break;
      case 'yearly_report':
        this.title = 'Import des donneés des rapports annuels';
        break;
      default:
        this.title = '';
        break;
    }
  }
}

export type ProgressEventType = 'start' | 'process' | 'end' | 'error';
export type ImportCategory = 'monthly_report' | 'yearly_report' | 'gallery' | 'location';

export interface ProgressEvent {
  type: ProgressEventType;
}
export interface BaseProgressEvent {
  type: ProgressEventType;
  category: ImportCategory;
}

export interface ProgressEventStart {
  type: 'start';
  category: ImportCategory;
  message?: string;
}

export interface ProgressEventProcess {
  type: 'process';
  category: ImportCategory;
  total: number;
  current: number;
  message: string;
}
export interface ProgressEventEnd {
  type: 'end';
  category: ImportCategory;
}
export interface ProgressEventError {
  type: 'error';
  category: ImportCategory;
}

export type ProgressEvents = ProgressEventStart | ProgressEventProcess | ProgressEventEnd | ProgressEventError;
